import React from 'react';

const OptInSuccess = () => {
  const data = [
    {
      text: 'Relax, we\'ll send you an email in the coming days/weeks when your rates are ready for review.',
      icon: require('../../../../www/images/coffee-break.png'),
    },
    {
      text: 'Review your rates to ensure there are no errors when they get loaded.',
      icon: require('../../../../www/images/quality-control.png'),
    },
    {
      text: 'Sign & submit your rates!',
      icon: require('../../../../www/images/deal-agreement.png'),
    },
  ];
  return (
    <div style={{ marginTop: '3em' }}>
      <div>Thank you for submitting your rates! Here's what happens next:</div>
      <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '2em' }}>
        {
          data.map(({ text, icon }, i) => (
            <div key={i} style={{ width: '250px', marginLeft: i > 0 ? '16px' : '0' }}>
              <div
                style={{
                  textAlign: 'center',
                  borderRadius: '50%',
                  border: '1px solid rgba(0, 0, 0, 0.67)',
                  width: '24px',
                  margin: 'auto auto 16px auto',
                }}
              >
                {i + 1}
              </div>
              <img src={icon} width={120} />
              <div style={{ marginTop: '16px', width: '250px' }}>
                {text}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default OptInSuccess;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/request/opt-in-success.jsx